"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaLibraryUploaderProvider = void 0;
const types_1 = require("./types");
const media_library_base_provider_1 = require("./media-library-base.provider");
class MediaLibraryUploaderProvider extends media_library_base_provider_1.MediaLibraryBaseProvider {
    static async getUploader() {
        const mediaLibraryFragment = await this.getMediaLibraryFragment();
        return mediaLibraryFragment.Uploader;
    }
    static async getMediaByIdentifier(relatedEntityId) {
        return (await this.getUploader()).getMediaByIdentifier(relatedEntityId);
    }
    static async uploadImageFromPc(options) {
        return (await this.getUploader()).uploadImageFromPc(options);
    }
    static async uploadDocumentFromPc(options) {
        return (await this.getUploader()).uploadDocumentFromPc(options);
    }
    static async uploadAudioFromPc(options) {
        return (await this.getUploader()).uploadAudioFromPc(options);
    }
    static async uploadAudioFromRecording(blob) {
        return (await this.getUploader()).uploadAudioFromRecording(blob);
    }
    static async uploadVideoFromPc(options) {
        return (await this.getUploader()).uploadVideoFromPc(options);
    }
    static async uploadDroppedImageFromPc(event) {
        return (await this.getUploader()).uploadDroppedImageFromPc(event);
    }
    static async uploadDroppedDocumentFromPc(event) {
        return (await this.getUploader()).uploadDroppedDocumentFromPc(event);
    }
    static async uploadDroppedAudioFromPc(event) {
        return (await this.getUploader()).uploadDroppedAudioFromPc(event);
    }
    static async uploadDroppedVideoFromPc(event) {
        return (await this.getUploader()).uploadDroppedVideoFromPc(event);
    }
    static async uploadFiles(files, type) {
        return (await this.getUploader()).uploadFiles(files, type);
    }
    static async waitUntilUploaded(model) {
        return new Promise((resolve, reject) => {
            model.on(types_1.ModelEvent.loaded, (data) => {
                model.off();
                resolve(data);
            });
            model.on(types_1.ModelEvent.failed, () => {
                model.off();
                reject();
            });
        });
    }
}
exports.MediaLibraryUploaderProvider = MediaLibraryUploaderProvider;
